export default {"src":"/_next/static/media/CPG.6ad09533.svg","height":18,"width":18};